export default "__VITE_ASSET__MgLmHg8c__"